import React from 'react';
import MathJax from ".././react-mathjax-preview";
import TextEditor from '../TextEditor';
import MQTCheckBox, { useCheckBoxStateHandler } from './MQTSelectBox';

const objectsToArray = (objectArray) => {
    return objectArray.sort((a, b) => {
        if(a.displayOrder !== undefined && a.displayOrder !== null 
            && b.displayOrder !== undefined && b.displayOrder !== null) {
                return parseInt(a.displayOrder) - parseInt(b.displayOrder)
        } else {
            return -1;
        }
    });
}

const MQTDisplayOption1 = (props) =>{

    const [selectedAnswers,onClick] = useCheckBoxStateHandler(props.mqt_answer_type);    //https://reactjs.org/docs/hooks-overview.html
    const {disableHTMLConversion,mqt_questions,mqt_answer_count,readOnly} = props;
    return <div>
        <table className='mqt-display-table'>
            <tbody>
                {
                    objectsToArray(Object.values(mqt_questions)).map(question=>{
                        let content;
                        console.log('selectedAnswers',selectedAnswers);
                        if(disableHTMLConversion){
                            content   =   React.createElement(MathJax,{"math":question.value,"key":question.id});
                        }else{
                            content   =   React.createElement(MathJax,{"math":TextEditor.getHTMLStringFromEditorState(question.value),"key":question.id});
                        }
                        let radioButtons = [];
                        let selectedAnswerArray;
                        if(selectedAnswers)
                            selectedAnswerArray = selectedAnswers[question.id];

                        for (let index = 0; index < mqt_answer_count; index++) {
                            
                            let checked = false;
                            if(selectedAnswerArray && selectedAnswerArray.length>0){
                                checked = selectedAnswerArray.includes(index);
                            }
                            radioButtons.push(<td> <MQTCheckBox type={props.mqt_answer_type} key={index+1} onClick={(isChecked)=>{onClick(question.id,index,isChecked)}} checked={checked} readOnly={readOnly} value={index+1}/></td>);
                        
                        }
                        return <tr>
                                    <td key='content'>{content}</td>
                                    {radioButtons}
                                </tr>
                    })
                }
            </tbody>
        </table>    
    </div> 
    
}

export default MQTDisplayOption1;